<template>
  <div class="addShopLabel">
    <div class="headler">优惠码▪新建优惠码</div>
    <div class="basicInfor">
      <div class="title">基本信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        size="small"
      >
        <el-form-item label="优惠码名称" prop="name">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.name"
            maxlength="10"
            show-word-limit
            style="width: 300px"
          ></el-input>
          <span class="hint">建议描述具体优惠，如5元优惠卷使用</span>
        </el-form-item>
        <el-form-item label="码类型" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="专属码"></el-radio>
            <el-radio label="通用码"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生成方式" prop="createWay">
          <el-radio-group v-model="ruleForm.createWay">
            <el-radio label="专属码"></el-radio>
            <el-radio label="通用码"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="库存" prop="inventory">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.inventory"
            show-word-limit
            style="width: 300px"
          >
            <template slot="append">个</template>
          </el-input>
        </el-form-item>

        <el-form-item label="每人限用" prop="restrict">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.restrict"
            show-word-limit
            style="width: 300px"
          >
            <template slot="append">个</template>
          </el-input>
          <span class="hint">设置0不限制</span>
        </el-form-item>

        <el-form-item label="活动时间" required>
          <el-col :span="4">
            <el-form-item prop="date1">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="ruleForm.date1"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="4">
            <el-form-item prop="date2">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="ruleForm.date2"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <div class="basicInfor discounts_rule">
      <div class="title">优惠规则</div>
      <el-form
        :model="ruleFormTwo"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        size="small"
      >
        <el-form-item label="优惠类型" prop="nonull">
          <el-radio-group v-model="ruleFormTwo.type">
            <el-radio label="抵扣"></el-radio>
            <el-radio label="折扣"></el-radio>
            <el-radio label="兑换"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="减免金额" prop="nonull">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleFormTwo.subMoney"
            show-word-limit
            style="width: 300px"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="使用条件" prop="nonull">
          <span class="hint" style="margin: 0 10px 0 0">满</span>
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleFormTwo.useCondition"
            show-word-limit
            style="width: 270px"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="适用类型" prop="nonull">
          <el-radio-group v-model="ruleFormTwo.applyType">
            <el-radio label="抵扣"></el-radio>
            <el-radio label="折扣"></el-radio>
            <el-radio label="兑换"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="核销场景" prop="nonull">
          <el-checkbox-group v-model="ruleFormTwo.scene">
            <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
            <el-checkbox label="地推活动" name="type"></el-checkbox>
            <el-checkbox label="线下主题活动" name="type"></el-checkbox>
            <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>

    <div class="operation_btn">
      <el-button @click="returnUp">取消</el-button>
      <el-button type="primary">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        createWay: "",
        inventory: "", //库存
        restrict: "", // 每人限用
        type: "",
        region: "",
        date1: "",
        date2: ""
      },
      ruleFormTwo: {
        type: "",
        subMoney: "", // 减免金额
        useCondition: "", // 使用条件
        applyType: "",
        scene: []
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        nonull: [{ required: true, message: "内容不能为空", trigger: "blur" }], // 公共
        inventory: [
          { required: true, message: "请输入库存信息", trigger: "blur" }
        ],
        restrict: [
          { required: true, message: "请输入限用人数", trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择开始日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择结束日期",
            trigger: "change"
          }
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        createWay: [
          { required: true, message: "请选择生成方式", trigger: "change" }
        ]
      },

    };

  },
  methods: {
    returnUp() {
      this.$router.replace("promoCode")
    }
  }
};
</script>

<style lang="scss" scoped>
.addShopLabel {
  height: 100%;
  padding: 10px 25px 10px 10px;
  border-left: 1px solid #f0f0f0;
  overflow: auto;

  .headler {
    height: 50px;
    line-height: 50px;
    padding-left: 10px;
    font-size: 16px;
  }
  .basicInfor {
    padding: 15px 30px;
    background: #f0f0f0;
    border-radius: 3px;
    margin-bottom: 10px;

    .title {
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      font-size: 16px;
    }

    .hint {
      font-size: 14px;
      color: #989898;
      margin-left: 10px;
    }
  }

  .operation_btn {
    margin-top: 15px;
    text-align: center;
  }
}
</style>
